<template style='text-align:left'>

  <v-layout column>   
    <v-flex xs12>
      <v-layout row  py-0 my-0>
        <v-flex ml-0 xs4 py-0 my-0>
          <v-select outlined :items="$dayTypes" label="Days Type" v-focus autofocus
           v-model="serviceDays.type"></v-select>         
        </v-flex>
        <v-flex xs6 mx-2 pt-3> 

          Days <input type="number" v-model="serviceDays.days" min="0" max="5000" style='border:1px solid #888888;padding:4px'/>
        </v-flex>
      </v-layout>
    </v-flex>  
  </v-layout>
</template>        

<script>

export default {

  components: { },
  props: {
    serviceDays: null,
    person: null
  }
}
</script>

<style>
.lite {color:#aaaaaa} ;
</style>



// WEBPACK FOOTER //
// src/components/Person/EditServiceDays.vue